import { render, staticRenderFns } from "./officerDashboardView.vue?vue&type=template&id=05132fc8&scoped=true"
import script from "./officerDashboardView.vue?vue&type=script&lang=js"
export * from "./officerDashboardView.vue?vue&type=script&lang=js"
import style0 from "./officerDashboardView.vue?vue&type=style&index=0&id=05132fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05132fc8",
  null
  
)

export default component.exports